import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: { "max-width": "600", persistent: "" },
      model: {
        value: _vm.visibilidade,
        callback: function ($$v) {
          _vm.visibilidade = $$v
        },
        expression: "visibilidade",
      },
    },
    [
      _c(
        VForm,
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pa-4" },
            [
              _c(
                VCardText,
                [
                  _c(VRow, [
                    _c(
                      "h4",
                      { staticClass: "headline primary--text text-no-wrap" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.isEdicao ? "Editar" : "Adicionar") +
                            " Competência Técnica "
                        ),
                      ]
                    ),
                  ]),
                  _c(VRow, [
                    _vm._v(
                      " Digite o nome da competência a ser " +
                        _vm._s(_vm.isEdicao ? "editada" : "adicionada") +
                        " "
                    ),
                  ]),
                  _c(
                    VRow,
                    { staticClass: "mt-8" },
                    [
                      _c(VTextField, {
                        attrs: { autofocus: "", label: "Nome" },
                        model: {
                          value: _vm.nomeCompetencia,
                          callback: function ($$v) {
                            _vm.nomeCompetencia =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "nomeCompetencia",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VSpacer),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        disabled: _vm.nomeCompetencia.trim() === "",
                        color: "primary",
                        type: "submit",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.isEdicao ? "Editar" : "Adicionar") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", outlined: "" },
                      on: { click: _vm.toogle },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }